/**
 * "Quoted in F&O" (20 Oct 2026, lead decision S7): what sales quoted for this inquiry, as
 * the GROUND TRUTH stage linked it. A compact block at the top of the section "Order
 * system" of the Details sheet (else "Quotation in the reply", else "Related mails"): the quotation and its F&O status, the sales order, the sales person ("Not
 * shown" for Germany and France), how it was linked, the lines matched, and the line
 * difference with the same table as the page "Learn from sales". With a sales order whose
 * lines are read (round 3): the ordered lines, the mark "Ordered" or "Not ordered" of each
 * quoted line, and the order lines that were not on the quotation when I2Q linked it (round 4:
 * with the lines of the sales order "Ordered", "Removed", "Cancelled", "Quantity changed",
 * "Added on the sales order" and the credit lines, `OrderExtras`). With
 * a customer PO (round 3, goal B): "Customer PO" and "In purchase order mail" under "Sales
 * order" (the same facts as the drawer, `poFactItems`).
 *
 * The field `ground_truth` of the case detail carries it (no capability: whoever sees the
 * case sees what sales quoted). Null: the case has no link yet, and the block is not shown.
 * Read only.
 */

import { Card, DescriptionList, Typography } from "@norican/react";

import { linkFactItems } from "@/features/learn-from-sales/inquiry-drawer";
import { DRAWER_LABELS, QUOTED_IN_FO_LABELS } from "@/features/learn-from-sales/labels";
import { LineDiffTable, OrderExtras } from "@/features/learn-from-sales/line-diff-table";
import { toGroundTruth } from "@/features/learn-from-sales/normalize";
import type { CaseGroundTruth } from "@/lib/api";

export function QuotedInFo({ truth }: { truth: CaseGroundTruth | null | undefined }) {
  if (!truth) {
    return null;
  }
  const link = toGroundTruth(truth);
  return (
    <Card variant="outline" padding="sm" className="min-w-0" data-quoted-in-fo={link.source}>
      <Card.Body className="flex min-w-0 flex-col gap-3">
        <Typography as="h3" variant="label" className="text-fg">
          {QUOTED_IN_FO_LABELS.title}
        </Typography>
        <DescriptionList items={linkFactItems(link)} />
        <Typography as="h4" variant="caption" tone="muted">
          {DRAWER_LABELS.diff}
        </Typography>
        <LineDiffTable rows={link.diff} counts={link.diff_counts} cards />
        <OrderExtras link={link} />
      </Card.Body>
    </Card>
  );
}
